export default "__VITE_ASSET__DfRjRBQh__"